import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'
import { Card, Icon, Tooltip, Button, Input, message as antMessage, Pagination, Tabs, Select, Modal, Form } from 'antd'
import { fetchUserInfo, requestAssetAccess } from '../../redux-flow/actions/users'
import { loadIndicacoes, loadIndicacao, resetIndicacaoForm, loadReferrals, loadCommissions, loadWithdrawals } from '../../redux-flow/actions/indicacoes';
import { request, getInfoLocalStorage, API_URL } from '../../utils/api'
import Navbar from '../../Components/Navbar'
import ContratoWrapper from './ContratoWrapper'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import CookieConsentComponent from '../../Components/CookieConsent'
import InsideMenu from '../../Components/InsideMenu'
import SideBar from '../../Components/SideBar'
import './indicacoes.css'

const { TabPane } = Tabs;
const { Option } = Select;

const LoadingComponent = () => (
    <div style={{ textAlign: 'center' }}>
        <Icon type="loading" />
    </div>
)

class Indicacoes extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            id_contrato: '', 
            asaActive: false,
            tipoIndicacao: '',
            heightWrapper: '0px',
            fillBackground: false,
            referralsLoaded: false,
            commissionsLoaded: false,
            currentPage: 1,
            pageSize: 10,
            codigoIndicacao: '',
            activeTab: '1',
            commissionsPage: 1,
            commissionsPageSize: 10,
            commissionsStatus: '',
            commissionsLoading: false,
            withdrawalModalVisible: false,
            withdrawalAmount: '',
            withdrawalBankName: '',
            withdrawalBankCode: '',
            withdrawalAccountNumber: '',
            withdrawalBranchNumber: '',
            withdrawalAccountType: 'CHECKING_ACCOUNT',
            withdrawalPixKey: '',
            withdrawalPixKeyType: 'cpf',
            withdrawalPaymentMethod: 'pix',
            withdrawalPassword: '',
            withdrawalBeneficiaryName: '',
            withdrawalDocument: '',
            withdrawalAccountDigit: '',
            withdrawalLoading: false,
            withdrawalsPage: 1,
            withdrawalsPageSize: 10,
            withdrawalsStatus: '',
            withdrawalsLoading: false,
        }
        console.log('Estado inicial activeTab:', this.state.activeTab);
    }

    componentDidMount() {
        const { userid, loadUserReferrals, loadUserCommissions, loadUserWithdrawals } = this.props
        const { commissionsPage, commissionsPageSize, commissionsStatus, withdrawalsPage, withdrawalsPageSize, withdrawalsStatus } = this.state;
        
        if (userid) {
            console.log('Carregando referidos para o usuário:', userid);
            loadUserReferrals(userid);
            loadUserCommissions(userid, commissionsPage, commissionsPageSize, commissionsStatus);
            loadUserWithdrawals(userid, withdrawalsPage, withdrawalsPageSize, withdrawalsStatus);
            
            if (!this.props.referralCode) {
                this.setState({ codigoIndicacao: '' });
            }
        } else {
            console.warn('Usuário não identificado. Não é possível carregar referidos.');
        }
        
        document.addEventListener('click', (e) => {
            if (e.target.closest('.btn-view-extract')) {
                console.log('Botão Ver Extrato clicado via event listener');
            }
        });
        
        window.scrollTo(0,0);
        window.addEventListener('scroll', this.handleWindowScroll, true)
    }

    componentDidUpdate(prevProps) {
        const { commissionsPage, commissionsPageSize, commissionsStatus } = this.state;
        
        if ((!prevProps.userid && this.props.userid) || (prevProps.userid !== this.props.userid)) {
            console.log('UserId atualizado, carregando referidos:', this.props.userid);
            this.props.loadUserReferrals(this.props.userid);
            this.props.loadUserCommissions(
                this.props.userid, 
                commissionsPage, 
                commissionsPageSize, 
                commissionsStatus
            );
        }
        
        if (prevProps.referralCode !== this.props.referralCode && this.props.referralCode) {
            this.setState({ codigoIndicacao: this.props.referralCode });
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleWindowScroll, true)
    }

    handleWindowScroll = () => {
        this.setState({
            fillBackground: window.scrollY > 100
        })
    }

    handleClick = (id, tipoIndicacao) => () => {
        this.props.onSelectIndicacao(id)
        this.setState({asaActive: tipoIndicacao === 6 ? false : true, tipoIndicacao})
        window.scrollTo(0,0);
        window.addEventListener('scroll', this.handleWindowScroll, true)
    }

    openAsa = () => {
        if(this.state.asaActive) {
            this.setState({
                classIcon: '',
                asaActive: false,
                heightWrapper: '0px',
            })
        } else {
            this.setState({
                classIcon: 'rotateIcon',
                asaActive: true,
                heightWrapper: '300px',
            })
        }
    }

    openModalSenha = () => {
        this.setState({
            modalSenhaOpened: true
        })
    }
    
    openModalEndereco = () => {
        this.setState({
            modalEnderecoOpened: true
        })
    }

    closeModalSenha = () => {
        this.setState({
            modalSenhaOpened: false
        })
    }
    
    closeModalEndereco = () => {
        this.setState({
            modalEnderecoOpened: false
        })
        window.location.reload()
    }

    handleDismiss = () => {
        this.setState({
            show: false
        })
    }

    copiarCodigo = () => {
        const { referralLink } = this.props;
        const { codigoIndicacao } = this.state;
        
        const urlReferencia = referralLink || `${window.location.origin}/cadastro?referralCode=${codigoIndicacao || ''}`;
        
        try {
            navigator.clipboard.writeText(urlReferencia);
            antMessage.success('Link de indicação copiado para a área de transferência!');
        } catch (error) {
            console.error('Erro ao copiar para a área de transferência:', error);
            
            const textArea = document.createElement('textarea');
            textArea.value = urlReferencia;
            document.body.appendChild(textArea);
            textArea.select();
            
            try {
                document.execCommand('copy');
                antMessage.success('Link de indicação copiado para a área de transferência!');
            } catch (err) {
                antMessage.error('Não foi possível copiar o link. Por favor, copie manualmente.');
            }
            
            document.body.removeChild(textArea);
        }
    }

    handlePageChange = (page, pageSize) => {
        this.setState({ currentPage: page });
    }

    handleCommissionsPageChange = (page, pageSize) => {
        this.setState({ commissionsPage: page });
        this.props.loadUserCommissions(
            this.props.userid, 
            page, 
            pageSize || this.state.commissionsPageSize,
            this.state.commissionsStatus
        );
    }

    handleStatusChange = (value) => {
        this.setState({ commissionsStatus: value, commissionsPage: 1 });
        this.props.loadUserCommissions(
            this.props.userid, 
            1, 
            this.state.commissionsPageSize, 
            value
        );
    }

    handleTabChange = (activeKey) => {
        console.log('Mudando aba para:', activeKey);
        this.setState({ activeTab: activeKey });
    }

    handleViewExtract = () => {
        console.log('Botão Ver Extrato clicado, mudando para a aba 2');
        this.setState({ activeTab: '2' });
    }

    formatCurrency = (value) => {
        return new Intl.NumberFormat('pt-BR', { 
            style: 'currency', 
            currency: 'BRL' 
        }).format(value);
    }

    formatDate = (dateString) => {
        if (!dateString) return '-';
        return new Date(dateString).toLocaleDateString('pt-BR');
    }

    getStatusLabel = (status) => {
        switch(status) {
            case 'pending':
                return <span className="status-1">Pendente</span>;
            case 'approved':
                return <span className="status-3">Aprovado</span>;
            case 'rejected':
                return <span className="status-4">Rejeitado</span>;
            case 'paid':
                return <span className="status-6">Pago</span>;
            default:
                return <span className="status-5">Desconhecido</span>;
        }
    }

    openWithdrawalModal = () => {
        this.setState({
            withdrawalModalVisible: true,
        });
    }

    closeWithdrawalModal = () => {
        this.setState({
            withdrawalModalVisible: false,
        });
    }

    handleWithdrawalInputChange = (e) => {
        const { name, value } = e.target;
        
        if (name === 'withdrawalAmount') {
            const numericValue = value.replace(/\D/g, '');
            
            if (numericValue === '') {
                this.setState({ withdrawalAmount: '' });
                return;
            }
            
            const floatValue = parseFloat(numericValue) / 100;
            const formattedValue = floatValue.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
            
            this.setState({ withdrawalAmount: formattedValue });
        } else {
            this.setState({ [name]: value });
        }
    };

    handleWithdrawalAccountTypeChange = (value) => {
        this.setState({
            withdrawalAccountType: value
        });
    };

    handlePaymentMethodChange = (value) => {
        this.setState({
            withdrawalPaymentMethod: value
        });
    };

    handleWithdrawalPixKeyTypeChange = (value) => {
        this.setState({
            withdrawalPixKeyType: value
        });
    };

    requestWithdrawal = async () => {
        const {
            withdrawalAmount,
            withdrawalBankName,
            withdrawalBankCode,
            withdrawalAccountNumber,
            withdrawalBranchNumber,
            withdrawalAccountType,
            withdrawalPixKey,
            withdrawalPixKeyType,
            withdrawalPaymentMethod,
            withdrawalPassword,
            withdrawalBeneficiaryName,
            withdrawalDocument,
            withdrawalAccountDigit
        } = this.state;

        if (!withdrawalAmount || !withdrawalPassword) {
            antMessage.error('Por favor, informe o valor e a senha.');
            return;
        }
        
        if (withdrawalPaymentMethod === 'pix') {
            if (!withdrawalPixKey) {
                antMessage.error('Por favor, informe a chave PIX.');
                return;
            }
        } else {
            if (!withdrawalBankName || !withdrawalBankCode || !withdrawalAccountNumber || 
                !withdrawalBranchNumber || !withdrawalBeneficiaryName || !withdrawalDocument) {
                antMessage.error('Por favor, preencha todos os dados bancários.');
                return;
            }
        }

        const { referralData } = this.props;
        const availableBalanceText = referralData && referralData.commissionStats 
            ? (referralData.commissionStats.availableBalance || 0).toString() 
            : '0';
        
        const availableBalanceValue = parseFloat(availableBalanceText.replace(',', '.'));
        const withdrawalAmountValue = parseFloat(withdrawalAmount.replace('.', '').replace(',', '.'));
        
        console.log('Saldo disponível:', availableBalanceValue, 'Valor do saque:', withdrawalAmountValue);
        
        if (withdrawalAmountValue > availableBalanceValue) {
            antMessage.error('O valor do saque não pode ser maior que o saldo disponível.');
            return;
        }

        this.setState({ withdrawalLoading: true });

        let requestData;
        
        if (withdrawalPaymentMethod === 'pix') {
            requestData = {
                amount: withdrawalAmountValue,
                password: withdrawalPassword,
                paymentMethod: "pix",
                pixKey: withdrawalPixKey,
                pixKeyType: withdrawalPixKeyType,
                favorite: "salvar"
            };
        } else {
            requestData = {
                banco: withdrawalBankName,
                accountType: withdrawalAccountType,
                bankCode: withdrawalBankCode,
                branch: withdrawalBranchNumber,
                account: withdrawalAccountNumber,
                accountDigit: withdrawalAccountDigit,
                name: withdrawalBeneficiaryName,
                document: withdrawalDocument,
                type: "CPF",
                amount: withdrawalAmountValue,
                password: withdrawalPassword,
                favorite: "salvar"
            };
        }

        try {
            const response = await request('wallet/cash-out/', 'POST', requestData);
            
            if (response.code === 200 || response.code === 204 || response.code === 61) {
                antMessage.success('Solicitação de saque enviada com sucesso!');
                this.closeWithdrawalModal();
                
                this.props.loadUserReferrals(this.props.userid);
            } else {
                throw new Error(response.message || 'Falha ao solicitar saque');
            }
        } catch (error) {
            console.error('Erro ao solicitar saque:', error);
            antMessage.error(error.message || 'Erro ao solicitar saque. Por favor, tente novamente.');
        } finally {
            this.setState({ withdrawalLoading: false });
        }
    }

    handleWithdrawalsPageChange = (page, pageSize) => {
        this.setState({ withdrawalsPage: page });
        this.props.loadUserWithdrawals(
            this.props.userid, 
            page, 
            pageSize || this.state.withdrawalsPageSize,
            this.state.withdrawalsStatus
        );
    }

    handleWithdrawalsStatusChange = (value) => {
        this.setState({ withdrawalsStatus: value, withdrawalsPage: 1 });
        this.props.loadUserWithdrawals(
            this.props.userid, 
            1, 
            this.state.withdrawalsPageSize, 
            value
        );
    }

    render() {
        const {
            logged,
            userLogged,
            indicacoes,
            indicacaoInfoLoading,
            indicacaoInfo,
            onPermissao,
            isLoadingAccess,
            success,
            message,
            userid,
            onLoad,
            referrals,
            referralData,
            referralsLoading,
            referralCode,
            referralLink,
            pagination,
            commissions,
            commissionsLoading,
            commissionsPagination,
            withdrawals,
            withdrawalsLoading,
            withdrawalsPagination
        } = this.props
        
        const { codigoIndicacao } = this.state;
        
        const urlReferencia = referralLink || `${window.location.origin}/cadastro?referralCode=${codigoIndicacao || ''}`;
        
        const totalReferrals = referralData && referralData.referralStats ? 
            referralData.referralStats.totalReferrals || 0 : 0;
        
        const activeReferrals = referralData && referralData.referralStats ? 
            referralData.referralStats.totalActiveReferrals || 0 : 0;
        
        console.log('Dados de saldo:', referralData && referralData.balance);
        
        const availableBalance = referralData && referralData.commissionStats ? 
            (referralData.commissionStats.availableBalance || 0).toFixed(2).replace('.', ',') : '0,00';
        
        const styles = {
            table: {
                width: '100%',
                marginTop: '20px',
                backgroundColor: '#fff',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            },
            tableHeader: {
                backgroundColor: '#f5f5f5',
                fontWeight: 'bold',
            },
            tableCell: {
                padding: '12px 16px',
                borderBottom: '1px solid #e8e8e8',
            },
            tableRow: {
                '&:hover': {
                    backgroundColor: '#f9f9f9',
                },
            },
        };

        return (
            <>
                <Navbar userLogged={userLogged} loggedArea={true} />
                {!logged ? <Redirect to="/login" /> : userLogged.cpf === null || userLogged.cep === null ? <Redirect to="/finalizar-cadastro" /> : (
                    <div>
                        <div className="section minhaContaWrapper">
                            <Container>
                                <Row>
                                    <Col md={12} className="p-0">
                                        <InsideMenu />
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                        <div className={`section insideSec meuFlow ${indicacoes && indicacoes.length <= 1 ? 'oneContract' : ''}`}>
                            <Container>
                                <Row id="rowInvestimentos">
                                    <Col md={2} className="colProd p-0">
                                        <SideBar nivelVerificacao={userLogged.nivelVerificacao} tipoIndicacao={this.state.tipoIndicacao} asaActive={this.state.asaActive} permissao={userLogged.permissao} indicacoes={indicacoes} handleClick={this.handleClick} />
                                    </Col>
                                    <Col md={10} className="colCont pl-5">
                                        <Card>
                                            <div className="programaIndicacoes">
                                                <h1 className="mb-3">Programa de Indicações</h1>
                                                <p className="mb-4">Indique amigos e ganhe recompensas quando eles se cadastrarem e investirem.</p>
                                                
                                                <Row>
                                                    <Col md={6}>
                                                        <Card className="mb-4">
                                                            <h3>Seu Link de Indicação</h3>
                                                            <div className="d-flex align-items-center mt-3">
                                                                <Input 
                                                                    value={urlReferencia} 
                                                                    readOnly 
                                                                    style={{ width: '70%', marginRight: '10px' }}
                                                                />
                                                                <Button onClick={this.copiarCodigo} className="btnGrafico">
                                                                    Copiar
                                                                </Button>
                                                            </div>
                                                            <p className="mt-3">
                                                                Compartilhe este link com seus amigos para que eles possam se cadastrar usando sua indicação.
                                                            </p>
                                                        </Card>
                                                    </Col>
                                                    <Col md={6}>
                                                        <Card className="mb-4">
                                                            <h3>Suas Estatísticas</h3>
                                                            <Row className="mt-3">
                                                                <Col md={4} className="text-center">
                                                                    <h2>{totalReferrals}</h2>
                                                                    <p>Indicações Nivel 1</p>
                                                                </Col>
                                                                <Col md={8} className="text-center">
                                                                    <h2>R$ {availableBalance}</h2>
                                                                    <p>Saldo Disponível</p>
                                                                    <div className="d-flex justify-content-center mt-2">
                                                                        {/* <Button 
                                                                            onClick={this.handleViewExtract} 
                                                                            className="mr-2"
                                                                            type="primary"
                                                                            style={{ backgroundColor: '#3f51b5', borderColor: '#3f51b5' }}
                                                                        >
                                                                            <Icon type="file-text" /> Ver Extrato
                                                                        </Button> */}
                                                                        <Button 
                                                                            onClick={this.openWithdrawalModal} 
                                                                            type="primary"
                                                                            disabled={parseFloat((availableBalance || '0').replace(',', '.')) <= 0}
                                                                            style={{ backgroundColor: '#28a745', borderColor: '#28a745' }}
                                                                        >
                                                                            <Icon type="bank" /> Solicitar Saque
                                                                        </Button>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </Card>
                                                    </Col>
                                                </Row>
                                                
                                                <Modal
                                                    title="Solicitar Saque"
                                                    visible={this.state.withdrawalModalVisible}
                                                    onCancel={this.closeWithdrawalModal}
                                                    footer={[
                                                        <Button key="back" onClick={this.closeWithdrawalModal}>
                                                            Cancelar
                                                        </Button>,
                                                        <Button 
                                                            key="submit" 
                                                            type="primary" 
                                                            loading={this.state.withdrawalLoading} 
                                                            onClick={this.requestWithdrawal}
                                                        >
                                                            Solicitar
                                                        </Button>,
                                                    ]}
                                                >
                                                    <Form layout="vertical">
                                                        <Form.Item label="Valor do Saque (R$)">
                                                            <Input
                                                                name="withdrawalAmount"
                                                                placeholder="0,00"
                                                                value={this.state.withdrawalAmount}
                                                                onChange={this.handleWithdrawalInputChange}
                                                                style={{ width: '100%' }}
                                                                addonAfter={
                                                                    <Button 
                                                                        type="link" 
                                                                        size="small"
                                                                        onClick={() => {
                                                                            const maxValue = parseFloat((availableBalance || '0').replace(',', '.'));
                                                                            this.setState({ 
                                                                                withdrawalAmount: maxValue.toLocaleString('pt-BR', {
                                                                                    minimumFractionDigits: 2,
                                                                                    maximumFractionDigits: 2
                                                                                }) 
                                                                            });
                                                                        }}
                                                                    >
                                                                        Usar saldo total
                                                                    </Button>
                                                                }
                                                            />
                                                            <div style={{ fontSize: '12px', color: '#888', marginTop: '5px' }}>
                                                                Saldo disponível: R$ {availableBalance}
                                                            </div>
                                                        </Form.Item>
                                                        
                                                        <Form.Item label="Senha">
                                                            <Input.Password
                                                                name="withdrawalPassword"
                                                                placeholder="Digite sua senha"
                                                                value={this.state.withdrawalPassword}
                                                                onChange={this.handleWithdrawalInputChange}
                                                            />
                                                        </Form.Item>
                                                        
                                                        <Form.Item label="Método de Pagamento">
                                                            <Select
                                                                value={this.state.withdrawalPaymentMethod}
                                                                onChange={this.handlePaymentMethodChange}
                                                                style={{ width: '100%' }}
                                                            >
                                                                <Option value="pix">PIX</Option>
                                                                <Option value="bank">Transferência Bancária</Option>
                                                            </Select>
                                                        </Form.Item>
                                                        
                                                        {this.state.withdrawalPaymentMethod === 'pix' ? (
                                                            <>
                                                                <Form.Item label="Tipo de Chave PIX">
                                                                    <Select
                                                                        value={this.state.withdrawalPixKeyType}
                                                                        onChange={this.handleWithdrawalPixKeyTypeChange}
                                                                        style={{ width: '100%' }}
                                                                    >
                                                                        <Option value="cpf">CPF</Option>
                                                                        <Option value="cnpj">CNPJ</Option>
                                                                        <Option value="email">E-mail</Option>
                                                                        <Option value="phone">Telefone</Option>
                                                                        <Option value="random">Chave Aleatória</Option>
                                                                    </Select>
                                                                </Form.Item>
                                                                <Form.Item label="Chave PIX">
                                                                    <Input
                                                                        name="withdrawalPixKey"
                                                                        placeholder="Informe sua chave PIX"
                                                                        value={this.state.withdrawalPixKey}
                                                                        onChange={this.handleWithdrawalInputChange}
                                                                    />
                                                                </Form.Item>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <Form.Item label="Nome do Banco">
                                                                    <Input
                                                                        name="withdrawalBankName"
                                                                        placeholder="Ex: Banco do Brasil"
                                                                        value={this.state.withdrawalBankName}
                                                                        onChange={this.handleWithdrawalInputChange}
                                                                    />
                                                                </Form.Item>
                                                                <Form.Item label="Código do Banco">
                                                                    <Input
                                                                        name="withdrawalBankCode"
                                                                        placeholder="Ex: 001"
                                                                        value={this.state.withdrawalBankCode}
                                                                        onChange={this.handleWithdrawalInputChange}
                                                                    />
                                                                </Form.Item>
                                                                <Form.Item label="Agência">
                                                                    <Input
                                                                        name="withdrawalBranchNumber"
                                                                        placeholder="Número da agência"
                                                                        value={this.state.withdrawalBranchNumber}
                                                                        onChange={this.handleWithdrawalInputChange}
                                                                    />
                                                                </Form.Item>
                                                                <Form.Item label="Conta">
                                                                    <Input
                                                                        name="withdrawalAccountNumber"
                                                                        placeholder="Número da conta"
                                                                        value={this.state.withdrawalAccountNumber}
                                                                        onChange={this.handleWithdrawalInputChange}
                                                                    />
                                                                </Form.Item>
                                                                <Form.Item label="Dígito">
                                                                    <Input
                                                                        name="withdrawalAccountDigit"
                                                                        placeholder="Dígito da conta"
                                                                        value={this.state.withdrawalAccountDigit}
                                                                        onChange={this.handleWithdrawalInputChange}
                                                                    />
                                                                </Form.Item>
                                                                <Form.Item label="Nome do Beneficiário">
                                                                    <Input
                                                                        name="withdrawalBeneficiaryName"
                                                                        placeholder="Nome completo do beneficiário"
                                                                        value={this.state.withdrawalBeneficiaryName}
                                                                        onChange={this.handleWithdrawalInputChange}
                                                                    />
                                                                </Form.Item>
                                                                <Form.Item label="CPF/CNPJ do Beneficiário">
                                                                    <Input
                                                                        name="withdrawalDocument"
                                                                        placeholder="CPF ou CNPJ do beneficiário"
                                                                        value={this.state.withdrawalDocument}
                                                                        onChange={this.handleWithdrawalInputChange}
                                                                    />
                                                                </Form.Item>
                                                                <Form.Item label="Tipo de Conta">
                                                                    <Select
                                                                        value={this.state.withdrawalAccountType}
                                                                        onChange={this.handleWithdrawalAccountTypeChange}
                                                                        style={{ width: '100%' }}
                                                                    >
                                                                        <Option value="CHECKING_ACCOUNT">Conta Corrente</Option>
                                                                        <Option value="SAVINGS_ACCOUNT">Conta Poupança</Option>
                                                                    </Select>
                                                                </Form.Item>
                                                            </>
                                                        )}
                                                    </Form>
                                                </Modal>
                                                
                                                <Card className="mb-4">
                                                    <Tabs 
                                                        activeKey={this.state.activeTab} 
                                                        onChange={this.handleTabChange}
                                                        defaultActiveKey="1"
                                                        animated={true}
                                                    >
                                                        <TabPane tab="Indicações" key="1">
                                                            {referralsLoading ? (
                                                                <div className="text-center p-4">
                                                                    <Icon type="loading" style={{ fontSize: 24 }} />
                                                                    <p className="mt-2">Carregando suas indicações...</p>
                                                                </div>
                                                            ) : referrals && referrals.length > 0 ? (
                                                                <>
                                                                    <table style={styles.table}>
                                                                        <thead>
                                                                            <tr>
                                                                                <th style={styles.tableHeader}>Nome</th>
                                                                                <th style={styles.tableHeader}>Email</th>
                                                                                <th style={styles.tableHeader}>Data de Cadastro</th>
                                                                                <th style={styles.tableHeader}>Status</th>
                                                                                <th style={styles.tableHeader}>Nível 2</th>
                                                                                <th style={styles.tableHeader}>Nível 3</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {referrals.map((referido) => {
                                                                                return (
                                                                                    <tr key={referido.id} style={styles.tableRow}>
                                                                                        <td style={styles.tableCell}>{referido.name || '-'}</td>
                                                                                        <td style={styles.tableCell}>{referido.email || '-'}</td>
                                                                                        <td style={styles.tableCell}>{referido.createdAt ? new Date(referido.createdAt).toLocaleDateString('pt-BR') : '-'}</td>
                                                                                        <td style={styles.tableCell}>{referido.status === 'active' ? 'Ativo' : 'Inativo'}</td>
                                                                                        {referido.referralsByLevel && referido.referralsByLevel.map((levelData, index) => (
                                                                                            index <= 1 ? <td key={index} style={styles.tableCell}>{levelData.total || 0}</td> : null
                                                                                        ))}
                                                                                    </tr>
                                                                                );
                                                                            })}
                                                                        </tbody>
                                                                    </table>
                                                                    
                                                                    {pagination && pagination.totalPages > 1 && (
                                                                        <div className="text-center mt-4">
                                                                            <Pagination 
                                                                                current={pagination.page} 
                                                                                total={pagination.total}
                                                                                pageSize={pagination.limit}
                                                                                onChange={this.handlePageChange}
                                                                                showSizeChanger={true}
                                                                                pageSizeOptions={['10', '20', '50', '100']}
                                                                                onShowSizeChange={(current, size) => {
                                                                                    this.setState({ pageSize: size, currentPage: 1 });
                                                                                    this.props.loadUserReferrals(
                                                                                        this.props.userid
                                                                                    );
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <div className="alert alert-info mt-3">
                                                                    Você ainda não possui indicações. Compartilhe seu link e comece a ganhar!
                                                                </div>
                                                            )}
                                                        </TabPane>
                                                        <TabPane tab="Extrato de Comissões" key="2" id="extrato-comissoes">
                                                            <div className="mb-3 d-flex justify-content-end">
                                                                <Select 
                                                                    placeholder="Filtrar por status" 
                                                                    style={{ width: 200 }} 
                                                                    onChange={this.handleStatusChange}
                                                                    allowClear
                                                                >
                                                                    <Option value="pending">Pendente</Option>
                                                                    <Option value="approved">Aprovado</Option>
                                                                    <Option value="rejected">Rejeitado</Option>
                                                                    <Option value="paid">Pago</Option>
                                                                </Select>
                                                            </div>
                                                            
                                                            {commissionsLoading ? (
                                                                <div className="text-center p-4">
                                                                    <Icon type="loading" style={{ fontSize: 24 }} />
                                                                    <p className="mt-2">Carregando seu extrato de comissões...</p>
                                                                </div>
                                                            ) : commissions && commissions.length > 0 ? (
                                                                <>
                                                                    <table className="table mt-3">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Cliente</th>
                                                                                <th>Contrato</th>
                                                                                <th>Valor do Contrato</th>
                                                                                <th>Comissão</th>
                                                                                <th>Data</th>
                                                                                <th>Status</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {commissions.map(commission => (
                                                                                <tr key={commission.id}>
                                                                                    <td>{commission.client ? commission.client.nome : '-'}</td>
                                                                                    <td>{commission.contract ? `#${commission.contract.id}` : '-'}</td>
                                                                                    <td>{commission.contractValue ? this.formatCurrency(commission.contractValue) : '-'}</td>
                                                                                    <td>{commission.commissionValue ? this.formatCurrency(commission.commissionValue) : '-'}</td>
                                                                                    <td>{this.formatDate(commission.createdAt)}</td>
                                                                                    <td>{this.getStatusLabel(commission.status)}</td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                    
                                                                    {commissionsPagination && commissionsPagination.totalPages > 1 && (
                                                                        <div className="text-center mt-4">
                                                                            <Pagination 
                                                                                current={commissionsPagination.page} 
                                                                                total={commissionsPagination.total}
                                                                                pageSize={commissionsPagination.limit}
                                                                                onChange={this.handleCommissionsPageChange}
                                                                                showSizeChanger={true}
                                                                                pageSizeOptions={['5', '10', '20', '50']}
                                                                                onShowSizeChange={(current, size) => {
                                                                                    this.setState({ commissionsPageSize: size, commissionsPage: 1 });
                                                                                    this.props.loadUserCommissions(
                                                                                        this.props.userid,
                                                                                        1,
                                                                                        size,
                                                                                        this.state.commissionsStatus
                                                                                    );
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <div className="alert alert-info mt-3">
                                                                    Você ainda não possui comissões registradas.
                                                                </div>
                                                            )}
                                                        </TabPane>
                                                        <TabPane tab="Extrato de Saque" key="3" id="extrato-saque">
                                                            <div className="mb-3 d-flex justify-content-end">
                                                                <Select 
                                                                    placeholder="Filtrar por status" 
                                                                    style={{ width: 200 }} 
                                                                    onChange={this.handleWithdrawalsStatusChange}
                                                                    allowClear
                                                                >
                                                                    <Option value="pending">Pendente</Option>
                                                                    <Option value="approved">Aprovado</Option>
                                                                    <Option value="rejected">Rejeitado</Option>
                                                                    <Option value="paid">Pago</Option>
                                                                </Select>
                                                            </div>
                                                            
                                                            {this.props.withdrawalsLoading ? (
                                                                <div className="text-center p-4">
                                                                    <Icon type="loading" style={{ fontSize: 24 }} />
                                                                    <p className="mt-2">Carregando seu extrato de saques...</p>
                                                                </div>
                                                            ) : this.props.withdrawals && this.props.withdrawals.length > 0 ? (
                                                                <>
                                                                    <table className="table mt-3">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Data</th>
                                                                                <th>Valor</th>
                                                                                <th>Método</th>
                                                                                <th>Status</th>
                                                                                <th>Detalhes</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {this.props.withdrawals.map(withdrawal => (
                                                                                <tr key={withdrawal.id}>
                                                                                    <td>{this.formatDate(withdrawal.dataSolicitacao || withdrawal.createdAt)}</td>
                                                                                    <td>{this.formatCurrency(withdrawal.valor || withdrawal.amount)}</td>
                                                                                    <td>
                                                                                        {withdrawal.paymentMethod === 'pix' ? 'PIX' : 
                                                                                         withdrawal.saqueType === 'balance' ? 'PIX' : 'Transferência Bancária'}
                                                                                    </td>
                                                                                    <td>
                                                                                        {withdrawal.statusText ? 
                                                                                            <span className={`status-${withdrawal.status === 0 ? '1' : withdrawal.status === 1 ? '3' : withdrawal.status === 2 ? '4' : '6'}`}>
                                                                                                {withdrawal.statusText === 'pendente' ? 'Pendente' : 
                                                                                                 withdrawal.statusText === 'aprovado' ? 'Aprovado' : 
                                                                                                 withdrawal.statusText === 'negado' ? 'Rejeitado' : 
                                                                                                 withdrawal.statusText === 'pago' ? 'Pago' : 'Desconhecido'}
                                                                                            </span> : 
                                                                                            this.getStatusLabel(withdrawal.status)}
                                                                                    </td>
                                                                                    <td>
                                                                                        {(withdrawal.paymentMethod === 'pix' || withdrawal.saqueType === 'balance') ? (
                                                                                            <Tooltip title={`Chave PIX: ${withdrawal.paymentInfo ? withdrawal.paymentInfo.pixKey : (withdrawal.pixKey || '-')}`}>
                                                                                                <Icon type="info-circle" />
                                                                                            </Tooltip>
                                                                                        ) : (
                                                                                            <Tooltip title={`Banco: ${withdrawal.bankName || '-'} - Agência: ${withdrawal.branch || '-'} - Conta: ${withdrawal.account || '-'}`}>
                                                                                                <Icon type="info-circle" />
                                                                                            </Tooltip>
                                                                                        )}
                                                                                    </td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                    
                                                                    {this.props.withdrawalsPagination && (
                                                                        <div className="text-center mt-4">
                                                                            <Pagination 
                                                                                current={this.props.withdrawalsPagination.currentPage || this.props.withdrawalsPagination.page} 
                                                                                total={this.props.withdrawalsPagination.totalItems || this.props.withdrawalsPagination.total}
                                                                                pageSize={this.props.withdrawalsPagination.itemsPerPage || this.props.withdrawalsPagination.limit}
                                                                                onChange={this.handleWithdrawalsPageChange}
                                                                                showSizeChanger={true}
                                                                                pageSizeOptions={['5', '10', '20', '50']}
                                                                                onShowSizeChange={(current, size) => {
                                                                                    this.setState({ withdrawalsPageSize: size, withdrawalsPage: 1 });
                                                                                    this.props.loadUserWithdrawals(
                                                                                        this.props.userid,
                                                                                        1,
                                                                                        size,
                                                                                        this.state.withdrawalsStatus
                                                                                    );
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <div className="alert alert-info mt-3">
                                                                    Você ainda não possui saques registrados.
                                                                </div>
                                                            )}
                                                        </TabPane>
                                                    </Tabs>
                                                </Card>
                                                
                                                <Card className="mb-4">
                                                    <h3>Como Funciona</h3>
                                                    <Row className="mt-3">
                                                        <Col md={4} className="text-center">
                                                            <div className="passo-indicacao">
                                                                <div className="numero-passo">1</div>
                                                                <h4>Compartilhe</h4>
                                                                <p>Compartilhe seu link de indicação com amigos e familiares.</p>
                                                            </div>
                                                        </Col>
                                                        <Col md={4} className="text-center">
                                                            <div className="passo-indicacao">
                                                                <div className="numero-passo">2</div>
                                                                <h4>Cadastro</h4>
                                                                <p>Seus amigos se cadastram usando seu link de indicação.</p>
                                                            </div>
                                                        </Col>
                                                        <Col md={4} className="text-center">
                                                            <div className="passo-indicacao">
                                                                <div className="numero-passo">3</div>
                                                                <h4>Ganhe</h4>
                                                                <p>Quando eles investirem, você recebe uma recompensa.</p>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </div>
                                        </Card>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    </div>
                )}
                <CookieConsentComponent />
            </>
        )
    }
}

const mapStateToProps = (state) => ({
    logged: state.login.logged,
    userLogged: state.users.userLogged,
    indicacoes: state.indicacoes.indicacoes,
    indicacaoInfo: state.indicacoes.indicacaoInfo,
    indicacaoInfoLoading: state.indicacoes.indicacaoInfoLoading,
    isLoadingAccess: state.users.isLoadingAccess,
    success: state.users.success,
    message: state.users.message,
    userid: state.login.userid,
    referrals: state.indicacoes.referrals,
    referralData: state.indicacoes.referralData,
    referralsLoading: state.indicacoes.referralsLoading,
    referralCode: state.indicacoes.referralCode,
    referralLink: state.indicacoes.referralLink,
    pagination: state.indicacoes.pagination,
    commissions: state.indicacoes.commissions,
    commissionsLoading: state.indicacoes.commissionsLoading,
    commissionsPagination: state.indicacoes.commissionsPagination,
    withdrawals: state.indicacoes.withdrawals,
    withdrawalsLoading: state.indicacoes.withdrawalsLoading,
    withdrawalsPagination: state.indicacoes.withdrawalsPagination
})

const mapDispatchToProps = (dispatch) => ({
    onLoad: (userid) => {
        dispatch(loadIndicacoes(userid))
        dispatch(resetIndicacaoForm())
    },
    onSelectIndicacao: (id) => {
        dispatch(loadIndicacao(id))
    },
    onPermissao: (userid) => {
        dispatch(requestAssetAccess(userid))
    },
    loadUserReferrals: (userid) => {
        console.log('Disparando ação loadReferrals para userId:', userid);
        dispatch(loadReferrals(userid))
    },
    loadUserCommissions: (userid, page, limit, status) => {
        console.log('Disparando ação loadCommissions para userId:', userid);
        dispatch(loadCommissions(userid, page, limit, status))
    },
    loadUserWithdrawals: (userid, page, limit, status) => {
        console.log('Disparando ação loadWithdrawals para userId:', userid);
        dispatch(loadWithdrawals(userid, page, limit, status))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Indicacoes)